import type { ReactNode } from 'react';

/**
 * I mattoni del modulo.
 *
 * Tre soli, e bastano per novanta campi: un campo con la sua etichetta, una
 * domanda sì/no, un blocco che si aggiunge e si toglie. Il modulo del v2 fa
 * la stessa cosa ripetendo lo stesso markup novanta volte, ed è per questo che
 * una correzione va fatta novanta volte.
 *
 * Il testo che si vede è **in inglese**: lo compilano candidati negli Stati
 * Uniti. Il codice e i commenti restano in italiano, come nel resto del
 * sistema.
 */

export function Campo({
  etichetta,
  aiuto,
  obbligatorio,
  errore,
  lungo,
  children,
}: {
  etichetta: string;
  aiuto?: string;
  obbligatorio?: boolean;
  errore?: string;
  /** Occupa tutta la riga: gli indirizzi e le domande lunghe. */
  lungo?: boolean;
  children: ReactNode;
}) {
  const classi = ['campo', lungo ? 'campo-lungo' : '', errore ? 'campo-sbagliato' : ''];
  return (
    <div className={classi.filter(Boolean).join(' ')}>
      <label>
        {etichetta}
        {obbligatorio && <span className="obbligatorio">*</span>}
      </label>
      {children}
      {aiuto && !errore && <span className="aiuto">{aiuto}</span>}
      {errore && <span className="errore-campo">{errore}</span>}
    </div>
  );
}

/**
 * Sì o no, due bersagli grandi.
 *
 * Non una tendina: col pollice una tendina si sbaglia, due pulsanti da
 * centoventi pixel no. E si vede la risposta senza aprire niente.
 */
export function SiNo({
  etichetta,
  valore,
  onCambia,
  obbligatorio,
  errore,
  aiuto,
}: {
  etichetta: string;
  valore: boolean | null | undefined;
  onCambia: (v: boolean) => void;
  obbligatorio?: boolean;
  errore?: string;
  aiuto?: string;
}) {
  return (
    <Campo etichetta={etichetta} obbligatorio={obbligatorio} errore={errore} aiuto={aiuto} lungo>
      <div className="sino" role="group" aria-label={etichetta}>
        <button type="button" aria-pressed={valore === true} onClick={() => onCambia(true)}>
          Yes
        </button>
        <button type="button" aria-pressed={valore === false} onClick={() => onCambia(false)}>
          No
        </button>
      </div>
    </Campo>
  );
}

/** Un blocco che si può togliere: un impiego, una referenza. */
export function Blocco({
  titolo,
  onTogli,
  children,
}: {
  titolo: string;
  onTogli?: () => void;
  children: ReactNode;
}) {
  return (
    <div className="blocco">
      <div className="blocco-testa">
        <span className="blocco-titolo">{titolo}</span>
        {onTogli && (
          <button type="button" className="btn-testo" onClick={onTogli}>
            Remove
          </button>
        )}
      </div>
      <div className="campi">{children}</div>
    </div>
  );
}
